<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="custom-card-header">
          Reset Password
          <v-spacer></v-spacer>
          <v-btn icon @click="toggle" color='white' ><v-icon>close</v-icon></v-btn>
        </v-card-title>
       <v-card-text>
            <v-form>
              <v-text-field v-if="this.successMessage == null || this.empty" v-model="password" label="Password" type="password"></v-text-field>
              <v-text-field v-if="this.successMessage == null || this.empty" v-model="confirm" label="Confirm Password" type="password"></v-text-field>
              <div v-if="(this.resetError != null) &&  (!this.empty)" class="text-center error--text mt-3 mb-5 error-message">{{resetError}}</div>
              <div v-if="(this.successMessage != null) && (!this.empty) && (this.notMatching === false)" class="text-center success--text mt-3 mb-5 success-message">{{successMessage}}</div>
              <div v-if="this.notMatching !== false" class="text-center error--text mt-3 mb-5 error-message">Passwords must match</div>
              <div v-if="this.currentLength <= 4 && password !== ''"  class="text-center error--text mt-3 mb-5 error-message">Password must be at least 5 characters</div>
            </v-form>
          </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn v-if="this.successMessage == null || this.empty" color="primary" class="ma-2" @click="reset">Confirm</v-btn>
          <v-btn v-if="this.successMessage == null || this.empty" color="primary" outlined class="ma-2" @click="toggle">Cancel</v-btn>
          <v-btn v-if="this.successMessage != null && !this.empty" color="primary" outlined class="ma-2" @click="toggle">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'password-reset',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    user: {
      type: Object
    }
  },
    data: () =>({
      empty: true,
        notMatching: false,
        password: null,
        confirm: null,
        currentLength: 0,
    }),
    created() {
        this.empty = true
    },
  methods: {
    reset () {
        this.currentLength = this.password.length
        this.notMatching = (this.password !== this.confirm)
        if (!this.notMatching && this.currentLength > 4) {
            this.empty = false
            this.resetPassword({email: this.user.email, password: this.password, confirm: this.confirm})
        }

    },
    ...mapActions({
      resetPassword: 'account/resetPasswordAdmin'
    })
  },
  computed: {
    ...mapGetters({
      resetError: 'account/adminError',
      successMessage: 'account/adminSuccess'
    })
  },
    watch: {
        confirm: function () {
            this.notMatching = (this.password !== this.confirm)
        },
        showDialog: function () {
            this.empty = true
            this.password = ""
            this.confirm = ""

        }
    }
}
</script>
<style scoped>
  .error-message {
    height: 20px;
    font-weight: bold;
  }
  .custom-card-header {
      background-color: #00A5C5;
      color: white;
  }
</style>
